document.addEventListener("turbo:load", () => {
  document.querySelectorAll(".job-actions").forEach((cell) => {
    cell.addEventListener("click", (event) => {
      event.stopPropagation();
    });
  });
});
